import moment from 'moment';

moment.locale('us');

export default {
  /**
   * Check if this a valid date in the format of MM/DD/YYYY
   *
   * @param {string} dateString
   * @returns {boolean}
   */
  isDateValid(dateString) {
    if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString)) {
      return false;
    }

    // Parse the date parts to integers
    const parts = dateString.split('/');
    const day = Number(parts[1]);
    const month = Number(parts[0]);
    const year = Number(parts[2]);

    // Check the ranges of month and year
    if (year < 1000 || year > 3000 || month === 0 || month > 12) {
      return false;
    }

    const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    // Adjust for leap years
    if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
      monthLength[1] = 29;
    }

    // Check the range of the day
    return day > 0 && day <= monthLength[month - 1];
  },

  /**
   * Convert a UTC javascript date to the local timezone
   * All dates from the server are in UTC format,
   * however they are not all being sent that way so we need to check.
   *
   * @param {string} dateString
   * @returns {Date}
   */
  convertUTCDateToLocalDate(dateString) {
    const isUTCFormat = dateString.charAt(dateString.length - 1) === 'Z';
    const UTCDateString = isUTCFormat ? dateString : `${dateString}Z`;
    const newDate = new Date(UTCDateString);

    return newDate;
  },

  /**
   * Format the ISO date to be human readable time
   *
   * @param {string} dateString
   * @returns {string}
   */
  formatDateAndTime(dateString) {
    if (!dateString) {
      return '';
    }

    const date = this.convertUTCDateToLocalDate(dateString);
    return moment(date).format('MM/DD/YY h:mma');
  },

  /**
   * Format the ISO date to be human readable dates. If the date string that is passed is NOT in the "YYYY-MM-DD" format, we convert it the local date. RFP Table is one instance has logic for this.
   *
   * @param {string} dateString
   * @param {string} outputFormat
   * @returns {string}
   */
  formatSimpleDate(dateString = '', outputFormat = 'MMMM Do, YYYY') {
    if (!dateString) {
      return '';
    }

    const isDateTime = !moment(dateString, 'YYYY-MM-DD', true).isValid();
    const date = isDateTime
      ? this.convertUTCDateToLocalDate(dateString)
      : dateString;

    return moment(date).format(outputFormat);
  },
};
